import {
    Button,
  FormControlLabel,
  TableCell,
  TableRow,
  Tabs,
  TextField
} from '@mui/material';
import { Box, styled } from '@mui/system';

export const myBlue = '#2596be';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    backgroundColor: '#f5f5f5',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)'
    }
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1976D2',
    transition: 'border-color 0.3s ease'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1976D2'
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#2596be'
  },
  marginBottom: '20px'
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.primary,
  padding: '12px 16px',
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 16,
  color: '#ffffff',
  padding: '14px 16px',
  backgroundColor: myBlue,
  fontWeight: 'bold'
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#E3F2FD'
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#ffffff'
  },
  '&:hover': {
    backgroundColor: '#B3E5FC',
    cursor: 'pointer'
  }
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  boxShadow: theme.shadows[2],
  marginBottom: theme.spacing(3)
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderRadius: '8px',
  backgroundColor: '#FF6F61',
  color: '#ffffff',
  '&:hover': {
    backgroundColor: '#E64A19'
  },
  display: 'flex',
  alignItems: 'center'
}));

export const CategoryWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '20px',
  marginBottom: '20px',
  paddingLeft: '20px',
  backgroundColor: '#f9f9f9',

  borderRadius: '8px',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
}));

export const CategoryRadio = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiRadio-root': {
    color: '#2596be',
    '&.Mui-checked': {
      color: '#1976D2'
    }
  },
  '& .MuiTypography-root': {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333'
  },
  '&:hover': {
    backgroundColor: '#e3f2fd', 
    borderRadius: '8px', 
    transition: 'background-color 0.3s'
  },
  padding: '10px',
  borderRadius: '8px'
}));
